"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isENSNameFormatIgnoreCase = isENSNameFormatIgnoreCase;
exports.toENSName = toENSName;
function isENSNameFormatIgnoreCase(str) {
    return str.indexOf('.') > 0;
}
function toENSName(str) {
    if (isENSNameFormatIgnoreCase(str)) {
        return str.toLowerCase();
    }
    throw new Error(`not a valid ENS name: "${str}"`);
}
//# sourceMappingURL=ENSName.js.map